import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const scrollableModalFn = /* @__PURE__ */ createRecipe('scrollableModal', {}, [])

const scrollableModalVariantMap = {}

const scrollableModalVariantKeys = Object.keys(scrollableModalVariantMap)

export const scrollableModal = /* @__PURE__ */ Object.assign(memo(scrollableModalFn), {
  __recipe__: true,
  __name__: 'scrollableModal',
  raw: (props) => props,
  variantKeys: scrollableModalVariantKeys,
  variantMap: scrollableModalVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, scrollableModalVariantKeys)
  },
})